'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var index = require('../Spinner/index.js');
var index$2 = require('../TextLink/index.js');
var styles = require('./styles.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var index$1 = require('../Language/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PreferencesStatus = _ref => {
  let {
    status,
    profileStatus,
    profileLink
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover,
    documentbodyNoneNone,
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const emphasize = status !== 'idle';
  const linkStyles = emphasize ? {
    fontWeight: 700,
    textDecorationLine: 'none'
  } : {};
  const iconStyles = status === 'error' ? {} : {
    fill: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.color) ?? (documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.color) ?? '#000'
  };
  return /*#__PURE__*/React__default["default"].createElement(styles.PreferencesStatusWrapper, {
    emphasize: emphasize
  }, status === 'loading' ? /*#__PURE__*/React__default["default"].createElement(index["default"], null) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(styles.PreferencesStatusDescription, null, /*#__PURE__*/React__default["default"].createElement(styles.PreferencesStatusIcon, _extends__default["default"]({
    icon: status === 'error' ? 'Error' : 'Favorite'
  }, iconStyles)), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: status === 'error' ? 'returnsPreferencesStatusDesc_error' : status === 'success' && profileStatus === 'pending' ? 'returnsPreferencesStatusDesc_pending' : 'returnsPreferencesStatusDesc'
  })), profileLink && /*#__PURE__*/React__default["default"].createElement(styles.PreferencesStatusLink, null, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    href: profileLink,
    target: "_blank",
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        ...linkStyles
      },
      sHover: {
        ...linksNoneHover,
        ...linkStyles
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: status === 'error' ? 'returnsPreferencesStatusLinkText_error' : status === 'success' && profileStatus === 'pending' ? 'returnsPreferencesStatusLinkText_pending' : 'returnsPreferencesStatusLinkText'
  })))));
};
var PreferencesStatus$1 = nthHookTheme.withThemeProvider(PreferencesStatus, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover', 'documentbodyNoneNone', 'bodytextDefaultNone']
});

exports["default"] = PreferencesStatus$1;
